import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import vSelect from "vue-select";
import { IExpeditionNotification, ITransporter, ExpeditionType } from "@/models";
import { Moment } from "moment";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { ToastHelper } from "@/helpers/ToastHelper";

@Component({
    name: "ExpeditionInit",
    components: {
        "v-select": vSelect,
        "datepicker": DatePicker,
    },
})

export default class ExpeditionInit extends Vue {

    @Prop({ required: false, default: 1 })
    public dock: number;

    @Prop({required: false, default: null })
    public expectedArrival: Moment;

    public modelDock: number;
    public modelExpectedArrival: Moment;
    public type: any;
    public types: any[];
    public comment: string = null;

    public selectedTransporter: ITransporter = null;

    public readonly modalExpeditionInit: string = "modalExpeditionInit";
    constructor() {
        super();

        this.modelDock = this.dock;
        this.modelExpectedArrival = this.expectedArrival;

        this.types = [
            {
                label: "Navette",
                value: 1,
            },
            {
                label: "DS",
                value: 2,
            },
            {
                label: "Autres",
                value: 3,
            },
        ];
        this.type = this.types[0];
    }

    public mounted(): void {
        this.$modal.show(this.modalExpeditionInit);
    }

    public get selectedNotification(): IExpeditionNotification {
        return this.$store.getters["expeditions/getSelectedNotification"]();
    }

    public get transporters(): ITransporter[] {
        return this.$store.getters["transporters/getActiveTransporters"]();
    }

    public get notBefore(): Date {
        return moment().hours(0).minutes(0).toDate();
    }

    public validate(): void {
        if (this.isValid()) {
            let data = {};
            if (this.selectedNotification !== null) {
                data = {
                    dock: this.modelDock,
                    transporter: this.selectedNotification.askAppointment.transporter,
                    expectedArrival: moment(this.modelExpectedArrival).seconds(0).milliseconds(0).toISOString(true),
                    askAppointmentId: this.selectedNotification.askAppointment.askAppointmentId,
                    type: this.type.value,
                    comment: this.comment,
                };
            } else {
                data = {
                    dock: this.modelDock,
                    expectedArrival: this.modelExpectedArrival.seconds(0).milliseconds(0).toISOString(true),
                    transporter: this.selectedTransporter,
                    type: this.type.value,
                    comment: this.comment,
                };
            }
            this.$store.dispatch("expeditions/initExpedition", data).then(() => {
                this.$modal.hide(this.modalExpeditionInit);
            }).catch((reason) => {
                ToastHelper.expeditions.toastConflict();
            });
        }
        else {
            ToastHelper.general.invalidModel();
        }
    }

    public emitChange() {
        this.$emit("change");
    }

    public isValid(): boolean {
        if (this.type.value === 1 && (this.selectedTransporter === null && this.selectedNotification === null)) {
            return false;
        }
        else {
            return true;
        }
    }
}
